<div style="position:fixed; z-index:100; top:140px;left:0;height:100%;width:100%;background:rgba(0, 0, 0, 0.8)">
  <div class="clearfix" style="position:relative; margin:0 auto; top:10px; height: 300; width:320px;">
    <p [style.color]="'white'">{{ 'general.misc.loading' | translate }}</p>
    <img [style.marginTop]="'40px'" src="../../../assets/loader1.gif" alt="">
  </div>
</div>
